export default String.raw`
<g id="12.-Lista-towarów_Prezentacja-atrybutów_Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="12.3_List-alt_attributes_v1-Copy-4" transform="translate(-16.000000, -1438.000000)">
        <g id="Group-10" transform="translate(16.930469, 1439.000000)">
            <rect id="Rectangle" class="bgColor lightBorderColor--stroke" x="0.0695307116" y="0" width="327" height="409"></rect>
            <g id="Group-26" transform="translate(12.069531, 62.000000)">
                <text id="Statystyczna-osoba-k" font-family="Roboto-Regular, Roboto" font-size="14" font-weight="normal" fill="#000000">
                    <tspan x="0" y="233">Statystyczna osoba korzysta z telefonu nawet </tspan>
                    <tspan x="0" y="252">4h dziennie. Dlatego wiemy jak ważne jest </tspan>
                    <tspan x="0" y="271">kupno solidnego i sprawdzonego smartfona czy </tspan>
                    <tspan x="0" y="290">smartwatcha. Istniejemy na rynku kilkanaście </tspan>
                    <tspan x="0" y="309">lat. Doskonale znamy się na sprzęcie </tspan>
                    <tspan x="0" y="328">multimedialnym. Nie ryzykuj, kup u nas.</tspan>
                </text>
                <image id="telefony-i-zegarki" x="0" y="0" width="303" height="200.7375" href="./img/previewElements/categoryDescription_1.png"></image>
            </g>
            <text id="Telefony-i-zegarki" font-family="Roboto-Bold, Roboto" font-size="16" font-weight="bold" class="primaryColorFont">
                <tspan x="12.0695307" y="30">Telefony i zegarki</tspan>
            </text>
            <line x1="-2.72187465e-13" y1="47" x2="326.998476" y2="46.0017433" id="Line" class="lightBorderColor--stroke" stroke-linecap="square"></line>
            <g transform="translate(295, -10)">
                <use class="primaryColorFont primaryColorFont--stroke" xlink:href="#angle-up" width="48" height="48" transform="scale(10)"></use>
            </g>    
        </g>
    </g>
</g>
`;